<template>
  <div>
    <!-- empty Data component -->
    <empty-data v-if="emptyDataFlag" v-bind:text="emptyDataText"></empty-data>

    <!-- 휴가현황 리스트 -->
    <v-list flat class="leave-list">
      <v-list-item-group v-for="(item, i) in searchList" :key="i">
        <v-list-item @click="openViewer(item)">
          <v-list-item-content>
            <v-list-item-subtitle class="mb-1">
              <span class="font-weight-bold point-blue">
                {{ item.requestTimeNm }}
              </span>
              <span class="divider date">{{ item.applTermF }}</span>
            </v-list-item-subtitle>
            <v-list-item-title>{{ item.gntNm }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-icon class="align-self-center">
            <v-chip
              class="step"
              :class="item.statusChipClass"
              v-text="item.applStatusNm"
            ></v-chip>
          </v-list-item-icon>
          <v-list-item-icon class="align-self-center ml-1">
            <v-btn fab text width="24" height="24" color="grey">
              <v-icon size="24">mdi-chevron-right</v-icon>
            </v-btn>
          </v-list-item-icon>
        </v-list-item>
        <v-divider inset class="list-divider-line"></v-divider>
      </v-list-item-group>
    </v-list>
  </div>
</template>

<script>
/* 휴가현황 리스트 컴포넌트 */
import EmptyData from '@/components/common/EmptyData.vue';
import { getHolidayStaList } from '@/api/workStatus';
import messageConstants from '@/const/messageConstants.js';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import { mapGetters } from 'vuex';

dayjs.extend(isBetween);

export default {
  props: {
    searchParam: {
      type: Object,
    },
    gntGubunCd: {
      type: String,
    },
  },

  data: () => ({
    emptyDataFlag: false, // 조회결과없음 플래그
    searchList: [],
    appInfoParam: {},
    emptyDataText: messageConstants.emptyDataMsg_1,
  }),

  watch: {
    searchParam() {
      this.fetchHolidayStaList();
    },
    GET_DIALOG_CALLBACK(callback) {
      if (callback) {
        this.fetchHolidayStaList();
      }
    },
  },

  computed: {
    ...mapGetters('DIALOG', ['GET_DIALOG_CALLBACK']),

    GET_USER_DATA() {
      return this.$store.getters.GET_USER_DATA;
    },
  },

  methods: {
    /* 신청서뷰어 모달오픈 */
    openViewer(appInfo) {
      // console.log('appInfo : ' + JSON.stringify(appInfo));
      appInfo['applSabun'] = appInfo.sabun;
      this.$store.commit('DIALOG/SET_DIALOG_PARAM', appInfo);
      this.$store.commit('DIALOG/TOGGLE_MODAL', 'application_viewer');
    },

    /* 휴가현황 목록조회  */
    async fetchHolidayStaList() {
      const paramObj = {
        searchSabun: this.GET_USER_DATA.ssnSabun,
        gntGubunCd: this.gntGubunCd,
        searchSdate: this.searchParam.searchTerm.sdate,
        searchEdate: this.searchParam.searchTerm.edate,
      };

      try {
        const response = await getHolidayStaList(paramObj);
        const dataList = response.data.data;

        this.searchList = [];

        if (dataList.length > 0) {
          dataList.forEach(data => {
            this.searchList.push({
              ...data,
              requestTimeNm:
                data.closeDay != null
                  ? `${data.closeDay}일`
                  : `${data.requestHour}시간`,
              // 신청서상태코드 (21,31,98:결재처리중,수신처리중,승인요청중 / 23,33:결재반려,수신반려 / 99:처리완료)
              statusChipClass:
                data.applStatusCd == '99'
                  ? 'approval'
                  : data.applStatusCd == '23' || data.applStatusCd == '33'
                  ? 'draft'
                  : 'charge',
            });
          });
        }

        // 조회결과없음 플래그값 세팅
        this.emptyDataFlag = this.searchList.length < 1;

        // 스피너 OFF
        this.$store.commit('SPINNER/OFF_COMMON_SPINNER');
        return response;
      } catch (error) {
        console.log(error);
        // 스피너 OFF
        this.$store.commit('SPINNER/OFF_COMMON_SPINNER');
      }
    },
  },

  components: {
    EmptyData,
  },
};
</script>

<style></style>
